import { render } from "./SupportUserBanner.vue?vue&type=template&id=9c48b2a4&scoped=true"
import script from "./SupportUserBanner.vue?vue&type=script&lang=js"
export * from "./SupportUserBanner.vue?vue&type=script&lang=js"

import "./SupportUserBanner.vue?vue&type=style&index=0&id=9c48b2a4&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-9c48b2a4"]])

export default __exports__